<!--eslint-disable-->
<template>
    <div class="pool-settings">
        <form @submit.prevent="submit" novalidate>
            <h1 class="title" v-if="showTitle">{{(!sections.length || sections.length > 1) ? 'General' : sections[0].split('_').join(' ')}}</h1>
            <div class="form-group">
                <template v-if="isShow({ section: 'pool_name' })">
                    <label class="label-max mt-3">Give your pool a name</label>
                    <label class="label-mini mt-0" for="label">Pool name</label>
                    <input type="text" id="label" name="label" class="form-control" v-model="data.label"
                           v-validate="'required'" :class="{ 'is-invalid': errors.has('label') }">
                    <small class="text-danger" v-if="errors.has('label')">{{errors.first('label')}}</small>
                </template>

                <template v-if="isShow({ section: 'address' })">
                    <label class="label-max mt-3">Installation Address</label>
                    <label class="label-mini mt-0" for="addr1">Street Address</label>
                    <input type="text" v-model="data.addr1" placeholder="Street Address" name="Street Address" id="addr1"
                           :class="{'is-invalid': errors.has('Street Address')}" class="form-control"
                           v-validate="'required'">
                    <small class="text-danger" v-if="errors.has('Street Address')">{{errors.first('Street Address')}}</small>
                    <label class="label-mini" for="addr2">Address 2</label>
                    <input type="text" v-model="data.addr2" placeholder="Address 2" name="Address 2" id="addr2"
                           :class="{'is-invalid': errors.has('Address 2')}" class="form-control">
                    <small class="text-danger" v-if="errors.has('Address 2')">{{errors.first('Address 2')}}</small>

                    <label class="label-mini" for="city">City</label>
                    <input type="text" v-model="data.city" placeholder="City" name="City" id="city"
                           :class="{'is-invalid': errors.has('City')}" class="form-control"
                           v-validate="'required'">
                    <small class="text-danger" v-if="errors.has('City')">{{errors.first('City')}}</small>

                    <label class="label-mini" for="state">State</label>
                    <select v-model="data.state" name="State" id="state"
                            :class="{'is-invalid': errors.has('State')}" class="form-control"
                            v-validate="'required'">
                        <option value="" disabled>State</option>
                        <option v-for="state in states" :key="state.abbr" :value="state.abbr">{{state.name}} ({{state.abbr}})</option>
                    </select>
                    <small class="text-danger" v-if="errors.has('State')">{{errors.first('State')}}</small>

                    <label class="label-mini" for="zip">Zip Code</label>
                    <input type="tel" v-model="data.zip" placeholder="Zip Code" v-mask="'#####'" name="Zip Code" id="zip"
                           :class="{'is-invalid': errors.has('Zip Code')}" class="form-control"
                           v-validate="'required'">
                    <small class="text-danger" v-if="errors.has('Zip Code')">{{errors.first('Zip Code')}}</small>
                </template>

                <template v-if="isShow({ section: 'equipment' })">
                    <label class="label-max mt-3">{{ $t('equipment.size') }}</label>
                    <div class="answer">
                        <label class="label-mini mt-0" for="sizeGallons">{{ $t('equipment.size.gallons') }}</label>
                        <input type="number" inputmode="numeric" class="form-control" step="0.1"
                               :placeholder="$t('equipment.size.example')" id="sizeGallons" name="Size Gallons"
                               :title="$t('equipment.size.title')"
                               v-model="data.sizeGallons" v-validate="'numeric|required|between:100,500000'"
                               :class="{'is-invalid': errors.has('Size Gallons')}">
                        <small class="text-danger" v-if="errors.has('Size Gallons')">
                            {{ $t('equipment.size.invalid') }}
                        </small>

                        <div v-for="(item, index) in questions.filter(item => item.key == 'sizeGallons')[0].questions" :key="index" v-if="showDontKnow || item.value !== 'DONT_KNOW'" class="custom-control custom-radio">
                            <input class="form-check-input" type="radio" name="Size Gallons" :title="item.name"
                                   :value="item.value" v-model="data.sizeGallons" :id="'size_' + index">
                            <label class="form-check-label" :for="'size_' + index">{{item.name}}</label>
                        </div>
                    </div>
                </template>
                <template v-if="isShow({ section: 'dosing' }) || isShow({ section: 'measurement' })">
                    <label class="label-max dosing-time-label" v-if="senseOnly || sections[0] === 'measurement'">Set Measurement Time</label>
                    <label class="label-max dosing-time-label" v-else>Set Dosing Time</label>
                    <m-time-picker v-model="data.measDoseTime" :title="(senseOnly || sections[0] === 'measurement') ? 'Set Measurement Time' : 'Set Dosing Time'"/>
                </template>

                <template v-if="isShow({ section: 'dosing' }) && !senseOnly">
                    <label class="label-max" style="margin-top: 20px">Set Dosing Levels</label>

                    <label class="label-mini mt-0" for="freeClTarget">Free Cl Target level</label>
                    <input type="number" inputmode="decimal" class="form-control" step="0.1"
                           placeholder="Example: 1.0" id="freeClTarget" name="Free Cl Target"
                           title="Optional free chlorine target (goal) to 1 dec place"
                           v-model="data.freeClTarget" v-validate="'decimal_custom|min_value:0|max_value:10'"
                           :class="{'is-invalid': errors.has('Free Cl Target')}" :disabled="senseOnly">
                    <small class="text-danger" v-if="errors.has('Free Cl Target')">
                        Enter Free Cl target from 0.0 to 10.0 (normal: 0.3 - 2.0)
                    </small>

                    <label class="label-mini" for="phTarget">ph Target Level</label>
                    <input type="number" inputmode="decimal" class="form-control" step="0.1"
                           placeholder="Example: 7.5" id="phTarget" name="ph Target"
                           v-model="data.phTarget" v-validate="'decimal_custom|min_value:6.5|max_value:8.5'"
                           :class="{'is-invalid': errors.has('ph Target')}" :disabled="senseOnly">
                    <small class="text-danger" v-if="errors.has('ph Target')">
                        Enter pH target from 6.5 to 8.5 (normal: 7.2 - 7.8)
                    </small>
                </template>
                <div class="answer mt-3" v-for="question in questions.filter(item => item.key !== 'sizeGallons')"
                     v-if="isShow(question)" :id="question.name" :key="question.key">
                    <label class="label-max">{{ shortTitle ? question.short_title : question.title }}</label>
                    <div v-for="(item, index) in question.questions" :key="index" v-if="showDontKnow || item.value !== 'DONT_KNOW'" class="custom-control custom-radio">
                        <input class="form-check-input" type="radio" :name="question.key" :value="item.id"
                               v-model="data[question.key]" :id="question.name + '_' + index"
                               :class="{ 'is-invalid': errors.has(question.key) || errors.items.find(item => item.field === question.key) }" @click="data = Object.assign(data, item.more)">
                        <label :for="question.name + '_' + index" class="form-check-label">{{item.name}}</label>
                    </div>
                    <input v-if="isShowInput(question)" :name="`input_${question.name}`" class="form-control"
                           :id="`input_${question.name}`"
                           :type="question.input_type"
                           :min="question.input_min"
                           :max="question.input_max"
                           :step="question.input_step"
                           v-model="inputs[`input_${question.name}`]"
                           v-validate="question.rules"
                           :data-vv-as="question.name_as">
                    <small class="text-danger" v-if="errors.has(`input_${question.name}`)">
                        {{errors.first(`input_${question.name}`)}}
                    </small>
                </div>
            </div>
            <div v-if="messageShow" class="alert mx-3" :class="`alert-${messageType}`">{{messageText}}</div>
            <div class="text-right btn-box">
                <w-button class="save" btn-type="circle" :class="{floating: buttonFloat}" type="submit" id="question_submit" :disabled="!changed">
                    {{changed ? buttonText : 'Saved'}}
                </w-button>
            </div>
        </form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import states from '../assets/json/states.json'
import moment from 'moment-timezone'
import TimePicker from './TimePicker'
import i18n from '../../../i18n'

export default {
    name: 'Questions',
    props: {
        answers: {
            type: Object
        },
        messageType: {
            type: String,
            default: 'info'
        },
        messageText: {
            type: String,
            default: 'Your answers have been updated'
        },
        messageShow: {
            type: Boolean,
            default: false
        },
        buttonText: {
            type: String,
            default: 'Save'
        },
        buttonFloat: {
            type: Boolean,
            default: false
        },
        sections: {
            type: Array,
            default: () => []
        },
        shortTitle: {
            type: Boolean,
            default: false
        },
        showDontKnow: {
            type: Boolean,
            default: true
        },
        senseOnly: {
            type: Boolean,
            default: false
        },
        changed: {}
    },
    components: {
        'm-time-picker': TimePicker
    },
    data () {
        console.log('QUESTIONS tenant =' + this.$store.getters['tenant/tenant'])
        const tenantSuffix = this.$store.getters['tenant/tenant'] ? '_' + this.$store.getters['tenant/tenant'] : ''
        const localeSuffix = '_' + i18n.locale
        const questions = require('../assets/json/questions' + tenantSuffix + localeSuffix)
        return {
            questions: questions,
            states: states,
            data: {
                state: '',
                shape: '',
                sizeGallons: '',
                get sizeGallonsManual () {
                    return !!this.sizeGallons
                },
                measDoseTime: '12:00 am',
                measDoseHr: '00',
                measDoseMin: '00',
                type: '',
                surface: '',
                filterType: '',
                userCl: '',
                userClLiqProductPct: '',
                userClLiqBleachPct: '',
                userCalHypoPct: '',
                userAcid: '',
                userAcidMuriaticPct: '',
                userAcidBisulfatePct: '',
                userAcidSulfuricPct: '',
                cover: ''
                // lengthFeet: '',
                // lengthInches: '',
                // widthFeet: '',
                // widthInches: '',
                // deepEndFeet: '',
                // deepEndInches: '',
                // shallowEndFeet: '',
                // shallowEndInches: '',
                // freeClTarget: '',
                // phTarget: '',
            },
            dataClone: {},
            inputs: {}
        }
    },
    methods: {
        submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    const time = moment.utc(moment(this.data.measDoseTime, 'hh:mm a')).format('HH:mm')
                    this.data.measDoseHr = time.split(':')[0]
                    this.data.measDoseMin = time.split(':')[1]

                    this.data.zip = parseInt(this.data.zip)

                    this.$emit('save', this.questions.filter(item => item.key !== 'sizeGallons').reduce((obj, item) => {
                        const answer = item.questions.find(_item => _item.id === this.data[item.key])
                        // const input = document.getElementById(`input_${item.name}`)
                        return Object.assign(
                            obj,
                            { [item.key]: answer ? (answer.value === '[INPUT]' ? this.inputs[`input_${item.name}`] : answer.value) : '' },
                            (answer ? answer.more : {})
                        )
                    }, this.data))
                } else {
                    const selector = `[name="${this.errors.items[0].field}"]`
                    document.querySelector(selector).focus()
                }
            })
        },
        isShow (question) {
            return (this.sections.includes(question.section) || !this.sections.length) && (!question.relation || this.questions.filter(item => {
                return item.key !== 'sizeGallons' && !item.relation
            }).some(item => {
                return item.questions.some(_item => {
                    return _item.id === this.data[item.key] && _item.related && _item.related.includes(question.key)
                })
            }))
        },
        isShowInput (question) {
            const answer = question.questions.find(item => this.data[question.key] === item.id)
            const show = question.type === 'select_input' && answer && answer.value === '[INPUT]'
            if (!show) {
                this.$delete(this.inputs, `input_${question.name}`)
            }
            return show
        },
        updateData () {
            if (this.answers) {
                for (let key in this.answers) {
                    if (this.answers.hasOwnProperty(key)) {
                        if (
                            (this.answers.measDoseHr || this.answers.measDoseHr === 0) &&
                            (this.answers.measDoseMin || this.answers.measDoseMin === 0)
                        ) {
                            const utc = `${this.answers.measDoseHr}:${this.answers.measDoseMin}`
                            this.data.measDoseTime = moment.utc(utc, 'HH:mm').local().format('hh:mm a')
                        }
                        this.$set(this.data, key, this.answers[key])
                        if (typeof this.data[key] !== 'undefined') this.data[key] = this.answers[key]
                    }
                }

                this.questions.filter(item => item.key !== 'sizeGallons').forEach(item => {
                    const answer = item.questions.find(_item => {
                        return _item.value === this.data[item.key] &&
                            (!_item.more || Object.keys(_item.more).every((key) => this.data[key] === _item.more[key]))
                    })
                    if (!answer && item.type === 'select_input' && this.data[item.key]) {
                        const value = this.data[item.key]
                        this.data[item.key] = item.questions.find(_item => _item.value === '[INPUT]').id
                        this.$set(this.inputs, `input_${item.name}`, value)
                    } else {
                        this.data[item.key] = answer ? answer.id : ''
                    }
                })
                this.dataClone = Object.assign({}, this.data)
            }
        },
        handleChange () {
            this.$emit('update:changed', Object.keys(this.data).some(index => {
                return (index === 'measDoseMin' || index === 'measDoseHr') ? (parseInt(this.data[index]) !== parseInt(this.dataClone[index])) : (this.data[index] !== this.dataClone[index])
            }) || Object.keys(this.inputs).some(key => {
                return this.inputs[key] !== this.answers[key.replace('input_', '')] && document.getElementById(key)
            }))
        }
    },
    computed: {
        showTitle () {
            return parseInt(Cookies.get('mobile_app')) !== 1
        }
    },
    mounted () {
        this.updateData()
    },
    watch: {
        answers: {
            deep: true,
            handler () {
                this.updateData()
            }
        },
        data: {
            deep: true,
            handler () {
                this.handleChange()
            }
        },
        inputs: {
            deep: true,
            handler () {
                this.handleChange()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    input::placeholder {
        color: #C4CFD5;
    }

    .title {
        font-size: 22px;
        font-weight: 600;
        color: $text-color;
        margin-left: 18px;
        text-transform: capitalize;
        margin-bottom: 12px;
    }

    .pool-settings {
        padding-top: 18px;
        padding-bottom: 18px;
        text-align: left;
    }

    .form-control {
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-radius: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 22px;
        padding-left: 13px;
        font-size: 16px;
        border-color: #C4CFD5;
        background-color: inherit;
        color: $text-color;
    }

    .form-control:focus {
        border-color: #23B8DC;
        box-shadow: 0 0.2rem 0 0 #23b8dc54;
        background-color: inherit;
    }

    .form-control.is-invalid:focus {
        box-shadow: 0 0.2rem 0 0 #dc354540;
    }

    select, select:hover {
        -webkit-appearance: none;
    }

    label.label-mini {
        display: block;
        margin-left: 13px;
        font-size: 10px;
        color: $label-color;
        margin-bottom: 0;
        margin-top: 19px;
    }

    label.label-max {
        display: block;
        color: $text-color;
        font-weight: 700;
        font-family: Nunito, sans-serif;
        font-size: 16px;
        margin-bottom: 7px;
    }

    small {
        font-size: 11px;
        padding-left: 13px;
    }

    .answer {
        border-bottom: 1px solid #13719C;
        border-radius: 0;
        padding: 0 0 15px 0;
        margin-bottom: 12px;
    }

    .answer > .custom-control {
        padding-left: 12px;
        margin-top: 5px;
    }

    .answer > .form-control {
        margin-left: 12px;
        margin-top: 5px;
    }

    .answer > .custom-control > .form-check-label {
        font-size: 15px;
        color: $text-color;
    }

    /*.save {*/
    /*    width: 75%;*/
    /*}*/

    button.floating {
        position: fixed;
        right: 100px;
        bottom: 20px;
        max-width: 200px;
    }

    .btn-primary.floating:disabled {
        color: #23B8DC;
        background-color: #FFF;
        border-color: #23B8DC;
        opacity: 1;
        transition: all 1s;
    }

    /*@media (min-width: 769px) {*/
    /*    .save {*/
    /*        width: 25%;*/
    /*    }*/
    /*}*/

    @media (max-width: 769px) {
        .answer > .custom-control > .form-check-label {
            font-size: 15px;
        }
    }
</style>
